package com.nonopn.dispatchers

import kotlinx.coroutines.Dispatchers

actual val DefaultDispatcher = Dispatchers.Default
